import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShowAllServiceLocation } from "../../../../context/Slice/VendorManagementSlice";
import Select from "react-select";

const BusinessDetailsForm = ({
  formValues,
  handleChange,
  handlePinCodeChange,
  pinCodeError,
  showSuggestions,
  suggestions,
  handleSuggestionClick,
  setFormValues,
}) => {
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.VendorManagementR.AllLoc);

  useEffect(() => {
    dispatch(ShowAllServiceLocation());
  }, [dispatch]);

  // console.log(locations)
  // Map locations to options for the multi-select dropdown
  const locationOptions =
    locations?.filter((data)=> data.status === true)?.map((location) => ({
      value: location.LocationName,
      label: location.LocationName,
    })) || [];
    console.log(locationOptions)

  // Handle multi-select change
  const handleLocationChange = (selectedOptions) => {
    const selectedLocations = selectedOptions.map((option) => option.value);
    setFormValues((prevValues) => ({
      ...prevValues,
      serviceLocations: selectedLocations,
    }));
  };

  return (
    <div className="row gx-3 mb-3">
      {/* Owner Name */}
      <div className="col-md-6">
        <label>Owner Name</label>
        <input
          className="form-control"
          type="text"
          value={formValues.OwnerName}
          disabled
        />
      </div>
      {/* Business Email */}
      <div className="col-md-6">
        <label>Business Email</label>
        <input
          className="form-control"
          type="text"
          value={formValues.OwnerEmail}
          disabled
        />
      </div>
      {/* Company Name */}
      <div className="col-md-6">
        <label>Company Name</label>
        <input
          className="form-control"
          type="text"
          name="BusinessName"
          value={formValues.BusinessName}
          onChange={handleChange}
          disabled
        />
      </div>
      {/* Business Mobile Number */}
      <div className="col-md-6">
        <label>Business Mobile Number</label>
        <input
          className="form-control"
          type="text"
          value={formValues.OwnerMobile_number}
          disabled
        />
      </div>
      {/* Business WhatsApp Number */}
      <div className="col-md-6">
        <label>Business WhatsApp Number</label>
        <div className="whatsapp-number">
          <input
            className="form-control"
            type="text"
            name="whatsappNumber"
            value={formValues.OwnerWhatsapp_number}
            onChange={handleChange}
            disabled
          />
        </div>
      </div>
      {/* Description */}
      <div className="col-md-12">
        <label>Description</label>
        <textarea
          className="form-control"
          name="ServiceDescription"
          value={formValues.ServiceDescription}
          onChange={handleChange}
          rows="6"
          maxLength="3600"
          placeholder="Enter the service description (up to 600 words)"
          required
        ></textarea>
      </div>
      {/* City */}
      <div className="col-md-6">
        <label>City via pincode</label>
        <input
          className="form-control"
          type="text"
          name="city"
          value={formValues.OwnerCity}
          onChange={handleChange}
          required
        />
      </div>
      {/* Location */}
      <div className="col-md-6">
        <label>Location</label>
        <input
          className="form-control"
          type="text"
          name="location"
          value={formValues.OwnerADDRESS}
          onChange={handleChange}
          required
        />
      </div>
      {/* Service Locations - Multi-select Dropdown */}
      <div className="col-md-6">
        <label>Service Locations</label>
        <Select
          isMulti
          name="serviceLocations"
          options={locationOptions} // Dynamically fetched locations
          value={locationOptions.filter((option) =>
            formValues.serviceLocations.includes(option.value)
          )}
          onChange={(selectedOptions) => {
            setFormValues((prev) => ({
              ...prev,
              serviceLocations: selectedOptions.map((opt) => opt.value),
            }));
          }}
          closeMenuOnSelect={false}
          placeholder="Select Service Locations"
          className="basic-multiselect"
          classNamePrefix="select"
        />
      </div>
      {/* Banner Image */}
      <div className="col-md-6  mb-2">
        <label>Banner Image</label>
        <input
          className="form-control mb-0"
          type="file"
          name="BannerImage"
          onChange={handleChange}
          required
        />
        <small className="text-muted">
          Recommended dimensions should be 900 x 360{" "}
        </small>
      </div>

      {/* Images */}
      <div className="col-md-6">
        <label>Images (up to 9)</label>
        <input
          className="form-control"
          type="file"
          name="images"
          onChange={handleChange}
          multiple
          required
        />
      </div>
      {/* Videos */}
      <div className="col-md-6">
        <label>Video (Only 1)</label>
        <input
          className="form-control"
          type="file"
          name="video"
          onChange={handleChange}
          multiple
          // required
        />
      </div>
      {/* Social Media Links */}
      <div className="col-md-12">
        <label>Social Media Links</label>
        {formValues.SocialMediaHandle?.map((link, index) => (
          <div key={index} className="d-flex mb-2">
            <select
              className="form-select me-2"
              value={link.platform}
              onChange={(e) =>
                setFormValues((prev) => {
                  const updatedLinks = [...prev.SocialMediaHandle];
                  updatedLinks[index].platform = e.target.value;
                  return { ...prev, SocialMediaHandle: updatedLinks };
                })
              }
            >
              <option value="">Select Platform</option>
              <option value="instagram">Instagram</option>
              <option value="facebook">Facebook</option>
              <option value="twitter">Twitter</option>
            </select>
            <input
              className="form-control me-2"
              type="text"
              placeholder="Enter URL"
              value={link.url}
              onChange={(e) =>
                setFormValues((prev) => {
                  const updatedLinks = [...prev.SocialMediaHandle];
                  updatedLinks[index].url = e.target.value;
                  return { ...prev, SocialMediaHandle: updatedLinks };
                })
              }
              // required
            />
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() =>
                setFormValues((prev) => ({
                  ...prev,

                  SocialMediaHandle: [
                    ...prev.SocialMediaHandle,
                    { platform: "", url: "" },
                  ],
                }))
              }
            >
              Add Link
            </button>
            {formValues.SocialMediaHandle?.length > 1 && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() =>
                  setFormValues((prev) => {
                    const updatedLinks = prev.SocialMediaHandle.filter(
                      (_, idx) => idx !== index
                    );
                    return { ...prev, SocialMediaHandle: updatedLinks };
                  })
                }
              >
                Remove
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessDetailsForm;
